// extracted by mini-css-extract-plugin
export var emailBlockLink = "_lc-0";